module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_9"
    }
  }, [_c('span', [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("GARY STARED")]), _vm._v(" at him. “You’re sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan nodded, his heartbeat racing. “There’s a trace of him on everything in here. But on this phone? Zilch.” He shivered. Lord, he was tired.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Then who did hold it? Any sense of that?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Another cold shiver trickled through him. “I have no idea, but… I don’t like how it makes me feel.” His mind lurched into analysis mode. “How did the police connect Leo to this phone? It could have been anybody’s. Did the detectives try to trace its purchase?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t know offhand. Those kinds of answers will be in the file.” Gary peered at him. “You think it’s important?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It seems to me the police would want to establish some connection between Leo and this phone. Because what’s the alternative? They didn’t go the distance on this one because hey, another dead druggie, or….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Or?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan took a deep breath. “They wanted him to appear guilty to stop people from looking too deep.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Any luck?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mr. Deakins’s voice had both of them jumping.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan forced a smile. “Maybe? I’m not sure. But it gave me a better picture of Leo.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Not certain that’s a good thing, but hey….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I think we’d better be going.” Gary stood, giving Dan a meaningful glance.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan recognized that look. Gary was taking care of him. He knew how much these sessions wiped Dan out.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mr. Deakins bit his lip. “If there’s anything you need, any more information, call me, okay? I’m sorry you didn’t get to meet Fran. She called to say she’s stopped by the church to talk to the pastor.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We won’t stop looking,” Dan told him. Although he’d put Mr. Deakins’s earlier assertions down to parental rose-colored glasses, after holding that phone, Dan had changed his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Something about this was wrong. Very wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They started putting everything back into the boxes, but Mr. Deakins stopped them. “I’ll see to this. Thank you again for what you’re doing.” He held out his hand and Dan took it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then he had to fight hard not to betray his emotions.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Thank you for your time, Mr. Deakins, and for letting us look at Leo’s things,” Gary said, shaking hands with the man.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And for the excellent cookies,” Dan added.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They walked slowly toward the car. They got in, and Dan sagged into the seat.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He closed his eyes. “I will be. I just need a little time to recharge my batteries.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Unfortunately, Gary was getting to know him way too well. “Want to try that again?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He twisted in his seat to gaze at Gary. “You didn’t find it odd that Leo’s mom had to go to the store in the middle of baking? And didn’t return the whole time we were there? Which was quite a while, by the way.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You felt something when you shook Mr. Deakins’s hand, didn’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan nodded. “I think Leo was a mama’s boy. Maybe his death hit her hardest of all. She decided she couldn’t face raking up the past, so she went out. And while we were busy looking through all those boxes, her husband called her, told her we were still here, and she got upset. It was all right there in his head.” Together with Mr. Deakins’s feelings of protectiveness toward her, so overwhelming that Dan had struggled to break free.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So she really did go to see the pastor?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah, that part was true.” Dan couldn’t blame her.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“How about we go back to the precinct and spend the rest of the afternoon setting up interviews for tomorrow? We need to find Leo’s friends and former classmates, and that’ll take some time. And while we’re at it, we’ll see if there’s anything in the evidence that links Leo to the phone.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Does this task come with cookies?” Dan’s attempt at humor was forced, however. He couldn’t shake the way that phone had made his skin crawl.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s okay, you know,” Gary murmured as he pulled away from the curb. “I get it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hmm?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I might not be psychic, but even I could see this shook you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan squeezed his thigh. “It did, but I’ll get over it. The important thing now is to see what else we can learn. Because that phone has thrown a blanket of doubt over the circumstances of Leo’s death.” He sighed. “Travers was right, wasn’t he?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“About what?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He said to be careful what I wished for. I wanted an interesting case. Well, it looks as if we’ve got one.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Now to see where his gift led them next.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("AS SOON")]), _vm._v(" as they walked into the office, Dan headed for the file.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You’re looking for any reference to that phone, aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan sighed. “Yes. Because there has to be one.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He sank into his chair. “Think about it. If the police found a phone with incriminating evidence on it—names of drug dealers, et cetera—but with nothing to link it to Leo, then it’s someone’s clumsy attempt to make it look as if he really was dealing drugs.” He shuddered. “And I don’t get the sense that whoever held that phone was remotely clumsy.” He opened the file.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Let me take a look,” Gary offered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan deliberated for a moment before handing the file over. “Maybe that’s best. You know what to look for.” He forced a smile. “You’re the detective, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary stilled, his hand in midair. “You’re "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("not")]), _vm._v(" okay, are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m not firing on all eight, but give me a moment and I will be.” He proffered the file again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary took it and went to his desk.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan leaned back and closed his eyes. The ride back to the precinct had helped him ease down a little, but his mind wouldn’t quit. He couldn’t rid himself of the feeling they were on the brink of something.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Dan. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Dan")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He opened his eyes to find Gary smiling at him, holding a cup of coffee—and a cinnamon roll.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I think you need these.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He rubbed his eyes. “Did I fall asleep?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yup, and I didn’t disturb you. But I figured you’d want to hear this.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan sat upright. “What did you find?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“According to the report, the detectives traced Leo’s movements the week he died, trying to build up a picture. He visited a convenience store every day on the way into college. One of the things they found in his wallet was a receipt for a phone.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He bought it at the store? When?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Two days before he died.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And in two days he managed to amass all those numbers?” A thought occurred to him. “That receipt… did he pay by card?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary chuckled. “I knew you’d ask that. No, he paid cash. What was odd was that he paid for his drinks and snacks by card.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Did the report note the time he purchased the phone?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Let me check.” Gary went over to his desk and picked up the folder. He leafed through it. “Yeah, I thought so. There’s a copy of the receipt.” He frowned.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s a different time of day, isn’t it? You said he stopped by the store on his way to college.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That doesn’t mean anything. He could’ve bought it on the way home.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan’s pulse quickened. “I don’t think so. You can see what I’m getting at, can’t you? The only link between Leo and that phone is that receipt, but "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("anyone")]), _vm._v(" could have bought it and stuck it in his wallet. But to do that, they’d have to have known his routines.” He drew in a breath. “Someone was watching him.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary stared at him. “You don’t think you’re maybe jumping to conclusions?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m coming up with theories, that’s all.” Dan returned his stare. “I thought you said we had interviews to set up for tomorrow?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Have I told you recently that you can be really bossy sometimes?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan grinned. “But you love me.” He picked up his cup of coffee. “Now let’s get to work.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Wednesday, September 26, 2018")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("SO FAR")]), _vm._v(" that morning, they’d spoken with three of Leo’s friends and four of his former classmates, and a pattern was starting to emerge.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Leo was never flush with cash.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He owed everyone money.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Most of them hadn’t trusted him, but said he was likable.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They all said he was extremely intelligent but lazy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan found one common denominator very interesting—not one of them mentioned drugs. In fact, when pressed they all said Leo wasn’t the type.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Which backs up what his dad told us.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan thought Mr. Deakins had nailed it. Leo "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("had")]), _vm._v(" been unscrupulous, and one of his classmates had stated he hadn’t trusted Leo as far as he could throw him, but there seemed to have been something attractive about him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Everyone likes a bad boy, I guess.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They’d yet to talk to Leo’s professors. There was one more person on their list before that, Leo’s former roommate, Tyler Benedict. Gary had tracked him down to a laboratory at Harvard Vanguard Medical Associates in Back Bay. Benedict had been working there for a year, according to his tax records. He hadn’t liked the idea of them showing up at his place of work, so they’d arranged to meet him at the Starbucks next to his building during his lunch break.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan paused at the door to the coffee shop.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Something wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He turned to Gary. “Just hoping this interview is more useful than the previous ones. I don’t feel we’ve gotten any closer to discovering the truth.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Then let’s see what his roommate has to tell us.” Gary pushed open the door, and Dan inhaled the aroma of coffee, chocolate, and spice. He glanced at the café’s occupants. Several people sat along one wall, their gazes focused on their laptops. Others sat at tables, chatting animatedly. A guy in a suit had his nose buried in a newspaper.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And a young man in a black leather jacket over a plaid shirt was watching them closely.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan gave him a hopefully reassuring smile as he approached the guy’s table.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Tyler Benedict?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyler nodded. “And you’re the police.” He had a pleasant face, with blue eyes and black hair. A handsome face if it came to that.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Well, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("he")]), _vm._v(" is.” Dan pointed to Gary. “I’m a consultant who’s come along for the ride.” For some reason he was reluctant to share his involvement with the case.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan knew better than to question his instincts.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Can I get you something, Tyler?” Gary inquired.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyler gestured to his plastic cup of what looked like peach green-tea lemonade. “I’m good, thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“But I’ll have what he’s having,” Dan said with a smile. “As long as it comes with a muffin.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary raised his eyebrows. “Any specific requests?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Blueberry or chocolate.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary rolled his eyes and headed toward the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Can I ask you something?” Tyler unfastened the top button of his shirt.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why are you looking into Leo’s death again? I thought it was all done and dusted.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“All we know is how he died. As to who killed him, that’s still person or persons unknown, and the chief of police doesn’t like to admit defeat. So Leo’s case turned up in the cold cases department.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I see.” Tyler sucked on his straw.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“How long did you know Leo?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We met in the first semester at college. We were in the same dorm. Then we shared a place for the next couple of years.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So you must have known him pretty well,” Dan surmised.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyler nodded. “Better than most.” He cocked his head. “You said on the phone you’d been speaking with other people who knew him.” Dan tossed out a few names, and he smiled. “I haven’t been in touch with them in ages.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary rejoined them, placing a plastic cup and a chocolate muffin in front of Dan. “You know that’s going to go straight to your waistline, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyler chuckled. “You two have worked together for a while, haven’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan didn’t correct him. “Can I cut to the chase?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He blinked. “Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We’ve asked everyone we’ve interviewed about the notion that Leo was into drugs. Their replies were almost identical.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So you’re asking me now?” Tyler leaned back in his chair. “Okay, then. It’s bullshit. Leo didn’t use. Hell, he wouldn’t even take Tylenol. And as for the idea of him "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("pushing")]), _vm._v(" drugs? I never believed that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan was starting to believe the same thing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Besides, it doesn’t make any sense. People who sell drugs do it to make money, right? Well, Leo could barely scrape together the money for our spring-break vacation that year.” He shook his head. “And 2015 was "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("not")]), _vm._v(" his year.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan leaned forward. “Why do you say that?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyler took a long suck on his straw before replying. “First he got sick. Then he ended up dead. I’d call that a shit year.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary frowned. “He got sick?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyler nodded. “A few of us did, around April. We all had the same thing. Mind you, we were luckier than Charlie Bates—he died.” He shivered. “He was only twenty.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What did he die of?” Dan asked. “Not the same thing you all got?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyler shrugged, running his finger around the lid of his cup. “I don’t know. He had the same symptoms as us, that was for sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Something tugged at Dan’s senses.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Tell us more about this spring-break vacation.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“A bunch of us—me, Leo, Charlie, Liam, and Grant—we booked a place for the week in Fort Lauderdale. Great week too, but not long after we came back—maybe a week or so—we all started getting sick. Fever, terrible headaches, no energy. And then we all got the same rash.” He grimaced. “That was a souvenir we never expected.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Let’s get back to Leo.” Gary had his notebook in front of him. “When did you last see him?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“The day before the police called around to say he’d been found in Jamaica Plain. I didn’t know he’d ever even been there.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And how was he before he died?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyler frowned. “What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Well, was he his usual self?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He bit his lip. “Now that you mention it… he was… kinda buzzing.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan’s senses were suddenly alert. “Do you have any idea why?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyler lowered his gaze. “No clue whatsoever.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan’s heartbeat shifted into a higher gear, and he had to fight the urge to grab Tyler’s hand.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“There’s nothing else you can think of to tell us?” Gary tapped his notebook with his pen. “"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Anything")]), _vm._v(" that will help us discover the truth about what happened to him?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyler stood. “I’m sorry, but I’ve told you everything I know. Now, if you’ll excuse me, I have to get back to work. Good luck with the investigation.” And with that he pushed past their chairs and headed for the door. Dan twisted in his seat to watch his departure.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyler didn’t look back once.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan expelled a breath. “Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary frowned. “For what? The tea lemonade and muffin?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He shook his head. “No, for not giving me a look that said ‘shake his hand’ or something.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary’s frown deepened. “You’re not a performing seal, you know. And if you’d felt it was necessary to touch him, you were free to do so. But I do know such contact can wipe you out.” He cocked his head. “That’s not how you see me, is it? Pushing you forward all the time to ‘do your stuff’?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Shit")]), _vm._v(". Dan was being way too sensitive about this. He put it down to his reactions to Tyler.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary flung down his pen with a sigh. “Anyway, that was a bust. All we learned was that Leo got sick in April of that year. That doesn’t help us when we want to know why someone shot him in the back of the head in May.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t know about you, but "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I")]), _vm._v(" learned something,” Dan muttered. He broke a piece off his muffin and ate it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary gaped at him. “What did you learn?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan gestured to the door of the coffee shop. “Tyler Benedict just lied to us.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7955c008","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0009.vue
// module id = 81
// module chunks = 0